import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "收费公示",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0rem",
      "text-align": "center",
      "background-color": "aliceblue"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, [_createElementVNode("img", {
    src: "/img/fee.jpg",
    width: "100%",
    height: "300",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.preview && $options.preview(...args))
  }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "点击图片预览", -1)), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createElementVNode("img", {
    src: "/img/bu2.jpg",
    width: "100%",
    height: "300",
    alt: "",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.previewbu2 && $options.previewbu2(...args))
  }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "点击图片预览", -1)), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)), _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)), _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)), _createElementVNode("img", {
    src: "/img/bu1.jpg",
    width: "100%",
    height: "700",
    alt: "",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.previewbu1 && $options.previewbu1(...args))
  }), _cache[13] || (_cache[13] = _createElementVNode("span", null, "点击图片预览", -1)), _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)), _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))], 4)]);
}